// removed by extract-text-webpack-plugin
module.exports = {"marketType":"_1h3hdsHnV-aHI5JeKphN3x","marketText":"_1riitJv8ZrBA8keyKx-rVn","customButtonContainer":"F59m_LJJ68e5mJIGqSNWk","innerText":"_1xnzXMjKNvOjI48SGkrlvj","buttonCustomStyle":"sz8hLRYjgAQcIk6sq1j_q"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/tennis/css/oddsCard.css
// module id = 978
// module chunks = 0